export const ROUND_STATUS_LABEL: Record<string, string> = {
  DRAFT: 'W przygotowaniu',
  REGISTRATION: 'Trwają zapisy',
  GROUPING: 'Tworzenie par',
  ACTIVE: 'W trakcie',
};

function daysFromToday(date: Date): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);

  return Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function formatRoundDateCompact(iso: string): string {
  const date = new Date(iso);
  const dateLabel = date.toLocaleDateString('pl-PL', { day: '2-digit', month: 'short' });
  const diffDays = daysFromToday(date);

  if (diffDays === 0) {
    return `dziś · ${dateLabel}`;
  }

  if (diffDays === 1) {
    return `jutro · ${dateLabel}`;
  }

  const weekday = date.toLocaleDateString('pl-PL', { weekday: 'short' });

  return `${weekday} · ${dateLabel}`;
}

export function formatRoundDate(iso: string): string {
  const diffDays = daysFromToday(new Date(iso));
  const compact = formatRoundDateCompact(iso);

  if (diffDays > 1 && diffDays < 7) {
    return `${compact} (za ${diffDays} dni)`;
  }

  return compact;
}
